import { httpRequest } from 'http'
import { push } from 'react-router-redux'
import { serialize } from 'helpers'
import { isFeatureAvailable } from 'helpers/accounts'

import { LEADERBOARD } from 'urls'
import { FEATURE_TYPES } from 'constants'
import prepareMeta from './helpers/leaderboards'

export const SET_PAGE = 'leaderboard/SET_PAGE'
export const REQUEST_SUCCESS = 'leaderboard/REQUEST_SUCCESS'
export const REQUEST_ERROR = 'leaderboard/REQUEST_ERROR'
export const REQUEST_START = 'leaderboard/REQUEST'

export function startRequest() {
    return {
        type: REQUEST_START,
    }
}

const DEFAULT_VEHICLE_LEVEL = 10

export function updateData(vehicle_level = DEFAULT_VEHICLE_LEVEL, page = null) {
    return (dispatch) => {
        dispatch(setPage(vehicle_level, page))
        dispatch(requestLeaderboardData())
    }
}

export function setPage(vehicle_level, page) {
    return {
        type: SET_PAGE,
        payload: {
            page,
            vehicle_level,
        },
    }
}

export function requestSuccess(response) {
    return {
        type: REQUEST_SUCCESS,
        payload: {
            data: response.data,
            meta: prepareMeta(response.meta),
            page: Math.ceil(response.meta.offset / response.meta.limit),
            pagesTotal: Math.ceil(response.meta.total_count / response.meta.limit),
        },
    }
}

export function requestError() {
    return {
        type: REQUEST_ERROR,
        payload: {},
    }
}

export function requestLeaderboardData() {
    return async (dispatch, getState) => {
        dispatch(startRequest())

        const { recordsPerPage, vehicle_level, page } = getState().leaderboard

        const params = {
            vehicle_level,
            limit: recordsPerPage,
        }
        if (Number.isInteger(page)) {
            params.offset = page * recordsPerPage
        }
        httpRequest('/game_api/elo_leaderboards' + serialize(params)).then(
            response => dispatch(requestSuccess(response)),
            () => dispatch(requestError())
        )
    }
}

export function openLeaderboard(vehicle_level) {
    return (dispatch, getState) => {
        const isLeaderboardAvailable = isFeatureAvailable(getState().account, FEATURE_TYPES.LEADERBOARDS)
        if (!isLeaderboardAvailable) return

        dispatch(setPage(vehicle_level))
        dispatch(push(LEADERBOARD))
    }
}



// WEBPACK FOOTER //
// ./state/actions/leaderboard.js